export default class GroupedAudioContainer
{
    #groups = {};

    getGroup(namespace)
    {
        if (!this.#groups.hasOwnProperty(namespace))
        {
            this.#groups[namespace] = [];
        }
        return this.#groups[namespace];
    }

    getAudios(namespace)
    {
        if (namespace)
        {
            return Array.from(this.getGroup(namespace));
        }
        return Object.values(this.#groups).flat();
    }

    count(namespace)
    {
        if (namespace)
        {
            return this.getGroup(namespace).length;
        }
        return Object.values(this.#groups).flat().length;
    }

    addAudio(audio, namespace)
    {
        const group = this.getGroup(namespace);
        if (!group.includes(audio))
        {
            group.push(audio);
        }
    }

    removeAudio(audio, namespace)
    {
        const group = this.getGroup(namespace);
        const index = group.indexOf(audio);
        if (index >= 0)
        {
            group.splice(index, 1);
        }
    }
}
